var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgNewTagShadow = function SvgNewTagShadow(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 22,
    viewBox: "0 0 45 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1319_13227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 8.00009L43 8.0001V18.0001C43 19.1047 42.1046 20.0001 41 20.0001H4C2.89543 20.0001 2 19.1047 2 18.0001V8.0001L16 8.00009L22.2929 1.7072C22.6834 1.31668 23.3166 1.31668 23.7071 1.7072L30 8.00009Z",
    fill: "#38AF8D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.52 11.2161V17.0001H16.968C16.8827 17.0001 16.8107 16.9867 16.752 16.9601C16.696 16.9307 16.6414 16.8827 16.588 16.8161L13.568 12.9601C13.584 13.1361 13.592 13.2987 13.592 13.4481V17.0001H12.644V11.2161H13.208C13.2534 11.2161 13.292 11.2187 13.324 11.2241C13.3587 11.2267 13.388 11.2347 13.412 11.2481C13.4387 11.2587 13.464 11.2761 13.488 11.3001C13.512 11.3214 13.5387 11.3507 13.568 11.3881L16.6 15.2601C16.592 15.1667 16.5854 15.0747 16.58 14.9841C16.5747 14.8934 16.572 14.8094 16.572 14.7321V11.2161H17.52Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8881 12.0721V13.6761H22.9121V14.5041H20.8881V16.1401H23.4561V17.0001H19.8081V11.2161H23.4561V12.0721H20.8881Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1057 11.2161L31.3097 17.0001H30.3377L29.0737 13.0481C29.039 12.9521 29.007 12.8347 28.9777 12.6961C28.9617 12.7627 28.9457 12.8254 28.9297 12.8841C28.9137 12.9427 28.8963 12.9974 28.8777 13.0481L27.6017 17.0001H26.6257L24.8337 11.2161H25.7337C25.827 11.2161 25.9043 11.2387 25.9657 11.2841C26.0297 11.3267 26.0723 11.3854 26.0937 11.4601L27.0777 14.9201C27.099 15.0054 27.119 15.0987 27.1377 15.2001C27.159 15.2987 27.1803 15.4027 27.2017 15.5121C27.223 15.4001 27.2457 15.2947 27.2697 15.1961C27.2963 15.0974 27.3243 15.0054 27.3537 14.9201L28.4897 11.4601C28.511 11.3987 28.5523 11.3427 28.6137 11.2921C28.6777 11.2414 28.755 11.2161 28.8457 11.2161H29.1617C29.255 11.2161 29.331 11.2387 29.3897 11.2841C29.4483 11.3294 29.4923 11.3881 29.5217 11.4601L30.6537 14.9201C30.7097 15.0854 30.7603 15.2761 30.8057 15.4921C30.8403 15.2814 30.879 15.0907 30.9217 14.9201L31.9057 11.4601C31.9217 11.3934 31.9617 11.3361 32.0257 11.2881C32.0923 11.2401 32.171 11.2161 32.2617 11.2161H33.1057Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1319_13227",
    x: 1.5,
    y: 1.41431,
    width: 43,
    height: 20.5857,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1319_13227"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1319_13227",
    result: "shape"
  })))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgNewTagShadow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/New-Tag-Shadow.0bd1ba2efd511fc64b81a0540d4699d4.svg";